export default "__VITE_ASSET__c9996bfa__"